import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Divider } from 'antd';

import { Title } from '@/components/Typography';
import { BodyPartsScores } from './BodyPartsScores';
import { usePreliminaryAnalysis } from '@/components/views/PreliminaryAnalysis/context';
import { Hooks } from './hooks';
import { RebaDTO, IUseBodyParts } from './types';
import { Container, Score, WorstScore } from './styles';

const { useBodyParts } = Hooks;

interface RebaProps {
	data: RebaDTO;
}

export const Reba: React.FC<RebaProps> = ({ data: { file_id, score_seconds } }) => {
	const { rebaAngles, company_id, organization_id } = usePreliminaryAnalysis();

	const payload: IUseBodyParts = {
		organization_id: organization_id,
		company_id: company_id,
		file_id: file_id
	};

	const { isLoading, data, isError } = useBodyParts(payload);

	if (isLoading) {
		return <p>{I18n.get('Loading')}...</p>;
	}

	if (isError) {
		return <p>Error</p>;
	}

	return (
		<Row gutter={[0, 24]}>
			<Col offset={1} span={23}>
				<Row>
					<Title style={{ margin: 0 }} level={3}>
						{I18n.get('Movement by score (Kinebot/REBA)')}
					</Title>
				</Row>
			</Col>
			<Col offset={1} span={23}>
				<Row>
					<Container>
						<Col span={24}>
							<Row>
								<WorstScore>
									{I18n.get('Worst score')}: <Score>{score_seconds}</Score>
								</WorstScore>
							</Row>
						</Col>
						<Divider style={{ margin: 0 }} />
						<Col span={24}>
							<Row justify="space-evenly">
								<BodyPartsScores data={data} rebaAngles={rebaAngles.angles} />
							</Row>
						</Col>
					</Container>
				</Row>
			</Col>
		</Row>
	);
};
